// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3qi5f","removeIcon":"styles_removeIcon__3bafq"};